module.exports = __webpack_public_path__ + "img/4Z_legacy.4a7ed597.png";